import axios from 'axios'
import axiosInstance from "./AxiosInstance";
import config from "../config";

const { apiAppendPath } = config
let source

export const create = (type, data) => axiosInstance.post(
	`${apiAppendPath.templatesAppendPath}`,
	data,
	{ params: { type } }
)

// Cancellable search — aborts any in-flight request before firing a new one.
// Use for filter/search interactions where only the latest result matters.
export const getMany = params => {

	source?.cancel();
	source = axios.CancelToken.source();

	try {
		return axiosInstance.get(
			`${apiAppendPath.templatesAppendPath}`,
			{ 
				params,
				cancelToken: source.token
			}
		)
	} catch (e) {
		if (!axios.isCancel(e)) throw e; 
	}
}

// Non-cancellable fetch — use for one-time reference data loads (e.g. building
// filter option lists) where the request must not be cancelled by a concurrent getMany call.
export const getManyRaw = params => axiosInstance.get(
	`${apiAppendPath.templatesAppendPath}`,
	{ params }
)


export const getOne = (id) => axiosInstance.get(
	`${apiAppendPath.templatesAppendPath}/${id}`
)

export const deleteOne = (id) => axiosInstance.delete(
	`${apiAppendPath.templatesAppendPath}/${id}`
)

export const update = (id, data) => axiosInstance.put(
	`${apiAppendPath.templatesAppendPath}/${id}`,
	data
)

export const bulkUpdate = (data) => axiosInstance.put(
	`${apiAppendPath.templatesAppendPath}/bulk`,
	data
)